import { jsx as _jsx } from "react/jsx-runtime";
import { RichText } from "../../../../eva-components/RichText";
import styles from "./Disclaimer.module.scss";
export const Disclaimer = ({ content }) => (_jsx(RichText, { isDarkMode: false, content: content, className: styles.disclaimer, dataTestId: "disclaimer" }));
//# sourceMappingURL=Disclaimer.js.map